<template>

  <div class="notice">
    <span >&nbsp{{$t('remind.' + word)}}</span>
  </div>
  <!--<div class="notice"> 不能设置font-size:14px 离谱
    <svg class="icon" aria-hidden="true" style="font-size:14px;">
      <use xlink:href="#icon-color-notice"></use>
    </svg>
    <span >&nbsp{{$t('regLogin.通知')}}</span>
  </div>-->

</template>

<script>
  import '@/assets/css/font/iconfont.css'
  import '@/assets/css/font/iconfont.js'
  export default {
    name: "Remind",
    props: {
      word:{
        type: String,
        default: ''
      }
    },
    setup(){


      return{

      }
    },
  }
</script>

<style scoped lang="less">

  .notice{
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
    padding-bottom: 5px;

    span {
      font-size: 10px;
      opacity: 0.6;
    }
  }

</style>